import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@sdbn/appclient';

import { ReportingGroupAdministrationComponent } from './component/reporting-group-administration.component';
import { ColorPickerModule } from 'src/tmc-common/components/color-picker/color-picker.module';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/appclient';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    ColorPickerModule,
    DictionaryModule,
    ApplicationClientCommonModule,
    CommonTranslationModule
  ],
  declarations: [
    ReportingGroupAdministrationComponent
  ]
})
export class ReportingGroupAdministrationModule { }

